'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  margin: ', ';\n  position: relative; \n  top: ', '; \n'], ['\n  margin: ', ';\n  position: relative; \n  top: ', '; \n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledIcon = _styledComponents2.default.div(_templateObject, function (props) {
  return props.compact ? '0 18px' : '0';
}, function (props) {
  return props.compact ? '6px' : '0';
});

exports.default = StyledIcon;
//# sourceMappingURL=StyledIcon.js.map


//////////////////
// WEBPACK FOOTER
// ../upload-box/lib/StyledIcon.js
// module id = 170
// module chunks = 0